export default __webpack_public_path__ + "static/media/Caffe.a521983a.webp";